(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-blocks"] && !Shopify.designMode) return;
  try {
    
(function () {
  var isEditor = window.Shopify && window.Shopify.designMode;

  function initLazyBackgrounds(container) {
    var blocks = (container || document).querySelectorAll('.cbr-block[data-bg]');
    if (!blocks.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            el.style.backgroundImage = 'url(' + el.dataset.bg + ')';
            el.removeAttribute('data-bg');
            obs.unobserve(el);
          }
        });
      }, { rootMargin: '200px' });

      blocks.forEach(function (block) { observer.observe(block); });
    } else {
      blocks.forEach(function (block) {
        block.style.backgroundImage = 'url(' + block.dataset.bg + ')';
      });
    }
  }

  if (!isEditor) {
    document.querySelectorAll('.cbr-block[data-bg]').forEach(function (el) {
      el.style.backgroundImage = '';
    });
    initLazyBackgrounds();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initLazyBackgrounds(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-og-slider"] && !Shopify.designMode) return;
  try {
    
  // Reinit slider
  document.addEventListener('DOMContentLoaded', function () {
    $('#og-slider-{{ section.id }}').lightSlider({
      item: 1,
      slideMargin: 0,
      loop: true,
      pager: true,
      controls: true,
      onSliderLoad: function () {
        $('#og-slider-{{ section.id }}').removeClass('cS-hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
